export default __webpack_public_path__ + "static/media/case_12.9f4fbc3f.jpg";